var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 78.91,
    viewBox: "0 0 79 78.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{clip-path:url(#d);}.c{opacity:0.97;}.d{clip-path:url(#i);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff357d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 79,
    height: 78.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14.383,
    height: 22.672
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.483,62.966c-1.425-1.424-1.435-2.184-.01-3.586a13.7,13.7,0,0,1,1.093-.891L46.62,54.546c-1.835.915-3.711,1.91-5.639,2.789a28.17,28.17,0,0,1-3.305,1.137,1.775,1.775,0,0,1-2.437-1.02c-.333-1.037.2-1.856,1.41-2.325A47.9,47.9,0,0,0,42.533,52.7,25.18,25.18,0,0,0,55.567,34.841,26.236,26.236,0,1,0,8.875,45.562a25.484,25.484,0,0,0,12.586,9.09c.442.148.892.283,1.318.47a1.726,1.726,0,1,1-1.148,3.256,37.141,37.141,0,0,1-4.573-1.742A29.345,29.345,0,0,1,1.114,37.557a51.861,51.861,0,0,1-.968-5.772c-.055-.34-.1-.683-.146-1.023V29.008c.167-1.384.279-2.778.511-4.151A29.152,29.152,0,0,1,11.522,6.334,28.72,28.72,0,0,1,26.818.155,29.119,29.119,0,0,1,44.519,3.9,28.9,28.9,0,0,1,57.146,18.011a29.259,29.259,0,0,1-.585,24.85c-.274.58-.585,1.143-.9,1.7-.3.533-.629,1.049-.9,1.493l4.121,4.093a12.71,12.71,0,0,1,1.05-1.216,1.746,1.746,0,0,1,2.583-.016c.133.113.253.243.377.367,7.914,7.914,5.137,5.125,13.042,13.048A9.574,9.574,0,0,1,63.176,76.6Zm8.646,3.661c.211.229.325.36.447.482,5.659,5.659.62.62,6.284,6.274a10.694,10.694,0,0,0,.857.748,6.064,6.064,0,0,0,8.894-1.682c1.5-2.6,1.06-5.424-1.241-7.727-7.409-7.42-4.129-4.133-11.545-11.547-.182-.182-.376-.349-.67-.62l-8.494,8.431,3.076,3.11c1.284-1.286,2.563-2.646,3.941-3.9a2.578,2.578,0,0,1,1.742-.716,2.292,2.292,0,0,1,1.364,1.133c.4.684.008,1.364-.508,1.888-1.353,1.37-2.729,2.718-4.146,4.125M49.6,52.132l3.451,3.456,2.858-2.835-3.377-3.41L49.6,52.132",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.345,32.967A20.675,20.675,0,1,1,33.094,53.6,20.768,20.768,0,0,1,12.345,32.967M46.648,43.3a17.121,17.121,0,0,0-26.627-21.51c-5.926,6.744-4.97,16.3-.619,21.383l3.276,3.456a17.179,17.179,0,0,0,20.72-.021Z",
    transform: "translate(-3.196 -3.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.535,77.378A1.82,1.82,0,0,1,37.9,77.36a1.819,1.819,0,0,1,3.637.019",
    transform: "translate(-9.812 -19.578)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(23.809 18.421)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.557,26.552a6,6,0,0,1,1.953,4.783,5.518,5.518,0,0,1-1.862,4.435,7.439,7.439,0,0,1-4.919,1.619l-.151,2.271H35.037l-.151-5.631H36.7a8.645,8.645,0,0,0,3.556-.575,2.1,2.1,0,0,0,1.226-2.088A2.322,2.322,0,0,0,40.91,29.7a2.108,2.108,0,0,0-1.6-.605,2.259,2.259,0,0,0-1.695.621A2.3,2.3,0,0,0,37,31.4H32.132a6.247,6.247,0,0,1,.771-3.33,5.884,5.884,0,0,1,2.483-2.346,8.494,8.494,0,0,1,3.98-.863,7.643,7.643,0,0,1,5.191,1.695M35.143,46.727a2.6,2.6,0,0,1-.863-1.982,2.681,2.681,0,0,1,.863-2.028,3.1,3.1,0,0,1,2.225-.817,3.066,3.066,0,0,1,2.2.817,2.681,2.681,0,0,1,.863,2.028,2.6,2.6,0,0,1-.863,1.982,3.1,3.1,0,0,1-2.2.8,3.136,3.136,0,0,1-2.225-.8",
    transform: "translate(-32.128 -24.857)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.60f6d2087dce5b0445b59b9badb8ddca.svg";
export { ForwardRef as ReactComponent };